// extracted by mini-css-extract-plugin
export default {"root":"shortlist_information-module___root___a77902c8"};